import { schema } from 'normalizr';
import { Space as SpaceApi } from 'api/space/space';
import { SpaceTab as SpaceTabApi } from 'api/space/space-tab';
import { SchemaKeys } from 'data/core';
import { dataNormalizer } from 'data/core/utils';
import { projectSchema } from 'data/projects/schema';
import { taskSchema } from 'data/tasks/schema';

export interface Space extends Omit<SpaceApi, 'project' | 'spaceTabs'> {
  project: number;
  spaceTabs: string[];
}

export const spaceSchema = new schema.Entity<SpaceApi>(
  SchemaKeys.Spaces,
  {},
  {
    idAttribute: (value: SpaceApi) => String(value.spaceId),
    processStrategy: (entity: SpaceApi) => {
      return entity.spaceTabs ? { ...entity } : { ...entity, spaceTabs: [] };
    },
  },
);

export const spaceTabSchema = new schema.Entity<SpaceTabApi>(
  SchemaKeys.SpaceTabs,
  {},
  {
    idAttribute: (value: SpaceTabApi) => String(value.spaceTabId),
    processStrategy: (entity: SpaceTabApi) =>
      entity.taskList ? { ...entity } : { ...entity, taskList: [] },
  },
);

spaceTabSchema.define({
  space: spaceSchema,
  taskList: [taskSchema],
});

spaceSchema.define({
  spaceTabs: [spaceTabSchema],
  project: projectSchema,
});

type SpaceEntities = Record<SchemaKeys.Spaces, Space>;

export const spaceNormalizer = (data: SpaceApi | SpaceApi[]) =>
  dataNormalizer<Space, SpaceEntities, SpaceApi>(data, spaceSchema);
